import { useState, useEffect } from 'react';
import { Users, Mail, User } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { apiFetch } from '../../utils/api';

export default function AudienceData() {
  const [audience, setAudience] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/audience')
      .then(r => r.json())
      .then(data => {
        setAudience(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="audience-data-page">
      <div className="flex items-center justify-between mb-8">
        <div>
          <p className="overline text-[#6B7280] mb-2">Manage</p>
          <h1 className="font-['Playfair_Display'] text-3xl font-bold text-[#0A1128] tracking-tight">
            Audience Data
          </h1>
        </div>
        <div className="flex items-center gap-2 bg-[#F4F4F4] px-4 py-2">
          <Users className="w-4 h-4 text-[#6B7280]" />
          <span className="text-sm font-medium text-[#0A1128]">{audience.length} subscribers</span>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-24">
          <div className="w-8 h-8 border-2 border-[#0A1128] border-t-transparent rounded-full animate-spin mx-auto" />
        </div>
      ) : audience.length === 0 ? (
        <div className="text-center py-24 border border-[#E5E7EB]">
          <Users className="w-8 h-8 text-[#6B7280] mx-auto mb-4" />
          <p className="text-[#6B7280] text-sm">No subscribers yet</p>
        </div>
      ) : (
        <div className="border border-[#E5E7EB]">
          <Table>
            <TableHeader>
              <TableRow className="bg-[#F4F4F4]">
                <TableHead className="text-xs uppercase tracking-widest text-[#6B7280] font-medium">
                  <div className="flex items-center gap-2"><User className="w-3 h-3" /> Name</div>
                </TableHead>
                <TableHead className="text-xs uppercase tracking-widest text-[#6B7280] font-medium">
                  <div className="flex items-center gap-2"><Mail className="w-3 h-3" /> Email</div>
                </TableHead>
                <TableHead className="text-xs uppercase tracking-widest text-[#6B7280] font-medium">Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {audience.map((item) => (
                <TableRow key={item.id} data-testid={`audience-row-${item.id}`}>
                  <TableCell className="font-medium text-[#0A1128]">{item.name}</TableCell>
                  <TableCell className="text-[#6B7280]">{item.email}</TableCell>
                  <TableCell className="text-[#6B7280] text-sm">
                    {new Date(item.created_at).toLocaleDateString()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
